import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <div className="privacy-header">
        <div className="container">
        
          <h1 className="privacy-title">Privacy Policy</h1>
        </div>
      </div>

      <div className="privacy-content">
        <div className="container">
          <div className="privacy-sections">
            
            <section className="privacy-section">
              <h2>1. Information We Collect</h2>
              <p>We collect information you provide directly to us, such as when you:</p>
              <ul>
                <li>Create an account or register for our services</li>
                <li>Book a tutoring session or consultation</li>
                <li>Contact us for support or inquiries</li>
                <li>Subscribe to our newsletter or marketing communications</li>
              </ul>
              <p>This may include your name, email address, phone number, educational background, and learning preferences.</p>
            </section>

            <section className="privacy-section">
              <h2>2. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul>
                <li>Provide, maintain, and improve our tutoring services</li>
                <li>Match you with appropriate tutors based on your needs</li>
                <li>Communicate with you about your sessions and our services</li>
                <li>Send you educational content and updates (with your consent)</li>
                <li>Ensure the safety and security of our platform</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>3. Information Sharing</h2>
              <p>We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except:</p>
              <ul>
                <li>To our trusted tutors for the purpose of providing educational services</li>
                <li>To service providers who assist us in operating our platform</li>
                <li>When required by law or to protect our rights and safety</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>4. Data Security</h2>
              <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.</p>
            </section>

            <section className="privacy-section">
              <h2>5. Your Rights</h2>
              <p>You have the right to:</p>
              <ul>
                <li>Access and update your personal information</li>
                <li>Request deletion of your data</li>
                <li>Opt-out of marketing communications</li>
                <li>Request a copy of your data</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>6. Cookies and Tracking</h2>
              <p>We use cookies and similar technologies to enhance your experience on our website, analyze usage patterns, and provide personalized content. You can control cookie settings through your browser preferences.</p>
            </section>

            <section className="privacy-section">
              <h2>7. Children's Privacy</h2>
              <p>Our services are designed for students of all ages. For users under 16, we require parental consent before collecting any personal information. Parents have the right to review, modify, or delete their child's information.</p>
            </section>

            <section className="privacy-section">
              <h2>8. Changes to This Policy</h2>
              <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.</p>
            </section>

            <section className="privacy-section">
              <h2>9. Contact Us</h2>
              <p>If you have any questions about this Privacy Policy or our data practices, please contact us:</p>
              <div className="privacy-contact-info">
                <p><strong>Email:</strong> privacy@skillbourn.com</p>
                <p><strong>Address:</strong> SkillBourn Academy, United Kingdom</p>
              </div>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
